import React from 'react'

export const CardOne = ({name, location, description, goLink}) => {

  return (
    <div className="card m-2">
      <div className="card-body">
        <h5 className="card-title text-center w-50 m-auto mb-3 mt-3">{name}</h5>
        <div className='card-img img-fluid'>
          {location}
        </div>
        <p className='card-text'> {description} </p>
        <p><a className="btn btn-link" href={goLink}> Ir a </a></p>
      </div>
    </div>
  )
}
